import { render, staticRenderFns } from "./SurfaceRange.vue?vue&type=template&id=3924cc8d&lang=pug&"
import script from "./SurfaceRange.vue?vue&type=script&lang=js&"
export * from "./SurfaceRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports